module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "href": "#/97808021888094#_idTextAnchor000"
    }
  }, [_vm._v("THE")]), _vm._v(" BACK SEAT")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303a5637","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802188809-7.vue
// module id = 84
// module chunks = 0